import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CloseIcon from '../../../icons/CloseIcon';

import useSessionContext from '../../useSessionContext/useSessionContext';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      height: '56px',
      background: '#F4F4F6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 1em',
      borderRadius: '12px 12px 0 0',
    },
    text: {
      fontWeight: 'bold',
    },
    closeChatWindow: {
      cursor: 'pointer',
      display: 'flex',
      background: 'transparent',
      border: '0',
      padding: '0.4em',
    },
  })
);

const SessionWindowHeader = () => {
  const classes = useStyles();
  const { setIsSessionWindowOpen } = useSessionContext();

  return (
    <div className={classes.container}>
      <div className={classes.text}>Meeting Details</div>
      <button className={classes.closeChatWindow} onClick={() => setIsSessionWindowOpen(false)}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default SessionWindowHeader;
